module.exports = __webpack_public_path__ + "img/user.5405d77c.png";